import { render, staticRenderFns } from "./AppScrollToTop.vue?vue&type=template&id=7b76a905"
import script from "./AppScrollToTop.vue?vue&type=script&lang=ts"
export * from "./AppScrollToTop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports